import { getWhatsAppLink, trackWhatsAppClick } from "@/lib/analytics";
import { MessageCircle } from "lucide-react";

export default function Header({ whatsappNumber }) {
  return (
    <header
      className="fixed top-0 z-50 w-full border-b border-white/5 bg-black/60 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <a href="#top" className="flex flex-col leading-none" data-testid="header-logo-link">
          <span className="text-lg font-bold tracking-tight text-white">
            Content House <span className="gold-text">TR</span>
          </span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
            Meta Reklam Yöneticisi
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Ana menü">
          <a href="#hizmetler" className="text-sm text-slate-300 transition-colors hover:text-gold-light" data-testid="nav-link-hizmetler">
            Hizmetler
          </a>
          <a href="#neden-biz" className="text-sm text-slate-300 transition-colors hover:text-gold-light" data-testid="nav-link-neden-biz">
            Neden Biz
          </a>
          <a href="#sektorler" className="text-sm text-slate-300 transition-colors hover:text-gold-light" data-testid="nav-link-sektorler">
            Sektörler
          </a>
          <a href="#iletisim" className="text-sm text-slate-300 transition-colors hover:text-gold-light" data-testid="nav-link-iletisim">
            İletişim
          </a>
        </nav>

        <a
          href={getWhatsAppLink(whatsappNumber)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick("header")}
          className="hidden items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-sm font-semibold text-black transition-colors hover:bg-gold-light sm:flex"
          data-testid="header-whatsapp-cta"
        >
          <MessageCircle className="h-4 w-4" />
          WhatsApp'tan Yaz
        </a>
      </div>
    </header>
  );
}
